import React from "react";
import { useTranslation } from "react-i18next";
import {
  ClipboardList,
  ConciergeBell,
  MessageSquare,
  Timer,
} from "lucide-react";
import { MetricCard, MetricCardsGrid } from "../shared";
import type { OperationsSummary } from "./types";

interface OperationsKpiCardsProps {
  summary: OperationsSummary;
}

export const OperationsKpiCards: React.FC<OperationsKpiCardsProps> = ({
  summary,
}) => {
  const { t } = useTranslation();

  const onTimeValue =
    summary.onTimePercent != null ? `${summary.onTimePercent}%` : "—";

  return (
    <MetricCardsGrid
      columns={4}
      className="w-full !grid-cols-2 xl:!grid-cols-4"
    >
      <MetricCard
        title={t("analytics.operations.kpi.totalRequests", "Total requests")}
        value={String(summary.totalRequests)}
        delta={summary.deltaTotalRequests?.text}
        trend={summary.deltaTotalRequests?.trend}
        icon={<ConciergeBell />}
        width="fill"
      />
      <MetricCard
        title={t(
          "analytics.operations.kpi.avgProcessingTime",
          "Avg. processing time",
        )}
        value={summary.avgProcessingTime}
        valueClassName="text-emerald-600"
        delta={summary.deltaAvgProcessingTime?.text}
        trend={summary.deltaAvgProcessingTime?.trend}
        icon={<Timer />}
        width="fill"
      />
      <MetricCard
        title={t(
          "analytics.operations.kpi.completedOnTime",
          "% completed on time",
        )}
        value={onTimeValue}
        valueClassName={
          summary.onTimePercent != null ? "text-red-600" : undefined
        }
        delta={summary.deltaOnTimePercent?.text}
        trend={summary.deltaOnTimePercent?.trend}
        icon={<ClipboardList />}
        width="fill"
      />
      <MetricCard
        title={t("analytics.operations.kpi.complaints", "Complaints")}
        value={String(summary.complaintCount)}
        valueClassName="text-red-600"
        delta={summary.deltaComplaints?.text}
        trend={summary.deltaComplaints?.trend}
        icon={<MessageSquare />}
        width="fill"
      />
    </MetricCardsGrid>
  );
};
